import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const Label = ({ children, htmlFor, required = false, className }) => (
  <div className={cn('flex gap-1', className)}>
    <Typography variant="label" size="medium" color="neutral-800" weight="medium" htmlFor={htmlFor}>
      {children}
    </Typography>
    {required && (
      <span aria-hidden="true" className={cn('text-xs text-danger-500')}>
        *
      </span>
    )}
  </div>
);

export default Label;
